import { makeAutoObservable } from "mobx";

import { UploadFile } from "../models/classes/upload-file.class";

export default class TranslationStore {
  private _uploadFiles: UploadFile[] = [];
  private _currentProgressessingFiles: UploadFile[] = [];
  private _textToTranslate = "";
  private _isTextProcessing = false;

  constructor() {
    makeAutoObservable(this);
  }

  public get textToTranslate(): string {
    return this._textToTranslate;
  }

  public set textToTranslate(value: string) {
    this._textToTranslate = value;
  }

  public get isTextProcessing(): boolean {
    return this._isTextProcessing;
  }

  public set isTextProcessing(value: boolean) {
    this._isTextProcessing = value;
  }

  public get uploadFiles(): UploadFile[] {
    return this._uploadFiles;
  }

  public set uploadFiles(value: UploadFile[]) {
    this._uploadFiles = value;
  }

  public get isAnyFileProgressing(): boolean {
    return this._currentProgressessingFiles.length > 0;
  }

  public addProgressingFile(file: UploadFile): void {
    this._currentProgressessingFiles.push(file);
  }

  public removeProgressingFile(file: UploadFile): void {
    this._currentProgressessingFiles = this._currentProgressessingFiles.filter(f => f.id !== file.id);
  }

  public containsProgressingFile(file: UploadFile): boolean {
    return this._currentProgressessingFiles.some(f => f.id === file.id);
  }

  public currentProgressingFiles(): UploadFile[] {
    return this._currentProgressessingFiles;
  }
}
